import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface NishtechStyle {
    cssOverride: InjectableCss;
}

export const fancyboxStyles: NishtechStyle = {
    cssOverride: {
        css: css`
            .fancybox-container {
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                -webkit-backface-visibility: hidden;
                height: 100%;
                left: 0;
                outline: none;
                position: fixed;
                top: 0;
                touch-action: manipulation;
                transform: translateZ(0);
                width: 100%;
                z-index: 99992;
                * {
                    box-sizing: border-box;
                }
            }
            .fancybox-bg {
                bottom: 0;
                left: 0;
                position: absolute;
                right: 0;
                top: 0;
                background: #1e1e1e;
                opacity: 0;
                transition-duration: inherit;
                transition-property: opacity;
                transition-timing-function: cubic-bezier(0.47, 0, 0.74, 0.71);
                background: rgba(54, 57, 54, 0.5);
            }
            .fancybox-inner {
                bottom: 0;
                left: 0;
                position: absolute;
                right: 0;
                top: 0;
            }
            .fancybox-stage {
                bottom: 0;
                left: 0;
                position: absolute;
                right: 0;
                top: 0;
                direction: ltr;
                overflow: visible;
                transform: translateZ(0);
                z-index: 99994;
            }
            .fancybox-is-open {
                .fancybox-bg {
                    opacity: 0.9;
                    transition-timing-function: cubic-bezier(0.22, 0.61, 0.36, 1);
                }
                .fancybox-stage {
                    overflow: hidden;
                }
            }
            .fancybox-caption {
                direction: ltr;
                opacity: 0;
                position: absolute;
                transition:
                    opacity 0.25s ease,
                    visibility 0s ease 0.25s;
                visibility: hidden;
                z-index: 99997;
                background: linear-gradient(
                    0deg,
                    rgba(0, 0, 0, 0.85) 0,
                    rgba(0, 0, 0, 0.3) 50%,
                    rgba(0, 0, 0, 0.15) 65%,
                    rgba(0, 0, 0, 0.075) 75.5%,
                    rgba(0, 0, 0, 0.037) 82.85%,
                    rgba(0, 0, 0, 0.019) 88%,
                    transparent
                );
                bottom: 0;
                color: #eee;
                font-size: 14px;
                font-weight: 400;
                left: 0;
                line-height: 1.5;
                padding: 75px 44px 25px;
                pointer-events: none;
                right: 0;
                text-align: center;
                z-index: 99996;
            }
            .fancybox-infobar {
                direction: ltr;
                opacity: 0;
                position: absolute;
                transition:
                    opacity 0.25s ease,
                    visibility 0s ease 0.25s;
                visibility: hidden;
                z-index: 99997;
                -webkit-font-smoothing: subpixel-antialiased;
                -webkit-touch-callout: none;
                color: #ccc;
                font-size: 13px;
                height: 44px;
                left: 0;
                line-height: 44px;
                min-width: 44px;
                mix-blend-mode: difference;
                padding: 0 10px;
                pointer-events: none;
                top: 0;
                -webkit-user-select: none;
                -moz-user-select: none;
                user-select: none;
            }
            .fancybox-navigation {
                .fancybox-button {
                    direction: ltr;
                    opacity: 0;
                    position: absolute;
                    transition:
                        opacity 0.25s ease,
                        visibility 0s ease 0.25s;
                    visibility: hidden;
                    z-index: 99997;
                    background-clip: content-box;
                    height: 100px;
                    opacity: 0;
                    position: absolute;
                    top: calc(50% - 50px);
                    width: 70px;
                    div {
                        padding: 7px;
                    }
                }
                .fancybox-button--arrow_left {
                    left: 0;
                    padding: 31px 26px 31px 6px;
                }
                .fancybox-button--arrow_right {
                    padding: 31px 6px 31px 26px;
                    right: 0;
                }
            }
            .fancybox-toolbar {
                direction: ltr;
                opacity: 0;
                position: absolute;
                transition:
                    opacity 0.25s ease,
                    visibility 0s ease 0.25s;
                visibility: hidden;
                z-index: 99997;
                right: 0;
                top: 0;
            }
            .fancybox-slide {
                -webkit-overflow-scrolling: touch;
                -webkit-backface-visibility: hidden;
                display: none;
                height: 100%;
                left: 0;
                outline: none;
                overflow: auto;
                padding: 44px;
                position: absolute;
                text-align: center;
                top: 0;
                transition-property: transform, opacity;
                white-space: normal;
                width: 100%;
                z-index: 99994;
                &:before {
                    content: "";
                    display: inline-block;
                    font-size: 0;
                    height: 100%;
                    vertical-align: middle;
                    width: 0;
                }
            }
            .fancybox-slide--current {
                display: block;
            }
            .fancybox-slide--html {
                padding: 6px;
                .fancybox-close-small {
                    color: currentColor;
                    padding: 10px;
                    right: 0;
                    top: 0;
                }
            }
            .fancybox-content {
                -webkit-overflow-scrolling: touch;
                background: #fff;
                display: inline-block;
                margin: 0;
                max-width: 100%;
                overflow: clip;
                padding: 44px;
                position: relative;
                text-align: left;
                vertical-align: middle;
                .as-image {
                    max-width: 65%;
                }
            }
            .fancybox-can-swipe {
                .fancybox-content {
                    cursor: grab;
                }
            }
            .fancybox-button {
                background: rgba(30, 30, 30, 0.6);
                border: 0;
                border-radius: 0;
                box-shadow: none;
                cursor: pointer;
                display: inline-block;
                height: 44px;
                margin: 0;
                padding: 10px;
                position: relative;
                transition: color 0.2s;
                vertical-align: top;
                visibility: inherit;
                width: 44px;
                color: #ccc;
                &:link {
                    color: #ccc;
                }
                &:visited {
                    color: #ccc;
                }
                &:hover {
                    color: #fff;
                }
                &:focus {
                    outline: none;
                }
                div {
                    height: 100%;
                }
                svg {
                    display: block;
                    height: 100%;
                    overflow: visible;
                    position: relative;
                    width: 100%;
                    path {
                        fill: currentColor;
                        stroke-width: 0;
                    }
                }
            }
            .fancybox-button[disabled] {
                color: #888;
                cursor: default;
                outline: none;
                &:hover {
                    color: #888;
                    cursor: default;
                    outline: none;
                }
            }
            .fancybox-button--play {
                svg {
                    &:nth-child(2) {
                        display: none;
                    }
                }
            }
            .fancybox-close-small {
                background: transparent;
                border: 0;
                border-radius: 0;
                color: currentColor;
                cursor: pointer;
                opacity: 0.8;
                padding: 8px;
                position: absolute;
                right: -12px;
                top: -44px;
                z-index: 401;
                &:hover {
                    color: currentColor;
                    opacity: 1;
                }
            }
            .fancybox-caption--separate {
                margin-top: -50px;
            }
            .fancybox-caption__body {
                max-height: 50vh;
                overflow: auto;
                pointer-events: all;
            }
            * {
                box-sizing: inherit;
            }
            &:after {
                box-sizing: inherit;
            }
            &:before {
                box-sizing: inherit;
            }
            img {
                display: inline-block;
                height: auto;
                max-width: 100%;
            }
            .popup {
                display: none;
                .image-holder {
                    overflow: hidden;
                    text-align: center;
                    width: 100%;
                }
                img {
                    height: 100%;
                }
            }
            .popup.fancybox-content {
                align-items: center;
                background: #fff;
                box-shadow: 0 3px 6px rgba(0, 0, 0, 0.26);
                display: flex !important;
                height: 95%;
                justify-content: center;
                left: 50%;
                max-width: 885px;
                position: fixed;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 100%;
            }
            .fancybox-button.fancybox-close-small {
                padding: 0;
                right: 15px;
                top: 10px;
            }
            .fancybox-button.fancybox-button--zoom {
                display: none !important;
            }
            @media (max-height: 576px) {
                .fancybox-slide {
                    padding-left: 6px;
                    padding-right: 6px;
                }
                .fancybox-close-small {
                    right: -6px;
                }
                .fancybox-caption {
                    padding-left: 12px;
                    padding-right: 12px;
                }
            }
            .popup {
                display: none;
                .image-holder {
                    overflow: hidden;
                    text-align: center;
                    width: 100%;
                }
                img {
                    height: 100%;
                }
            }
        `,
    },
};
